import { Component, OnInit } from '@angular/core';
import { CommunicationService } from './../../shared/services/communication.service';
import { ApiService } from './../../shared/services/api.service';
import { ListBase } from './../../shared/components/base/list/list.base.component';
import { BookingItem } from './../../models/bookings/bookings.model';

@Component({
  selector: 'swb-booking-items-list',
  templateUrl: './../../shared/components/base/list/list.base.component.html'
})
export class BookingItemsListComponent extends ListBase<BookingItem> implements OnInit {

  public url = 'booking-items';
  public urlPrefix = 'bookings';
  public routePrefix = 'items';

  constructor(
    _apiService: ApiService,
    _communicationService: CommunicationService
  ) {
    super(
      _apiService,
      _communicationService
    );
  }
}
